import React, { FC } from 'react';
import { Redirect, Switch, Route } from 'react-router-dom';
import { shallowEqual, useSelector } from 'react-redux';
import { MasterLayout } from '../../rbts/layout/MasterLayout';
import { PrivateRoutes } from './PrivateRoutes';
import { Logout, AuthPage } from '../modules/auth';
import { ConfirmPassword } from '../modules/auth/components/ConfirmPassword';
import { WalletConfirmPassword } from '../modules/auth/components/WalletConfirmPassword';
import { ErrorsPage } from '../modules/errors/ErrorsPage';
import { RootState } from '../../setup';
import { TerminosPage } from '../modules/terminos/TerminosPage';

const Routes: FC = () => {
  const isAuthorized = useSelector<RootState>(
    ({ auth }) => auth.user,
    shallowEqual
  );

  return (
    <Switch>
      <Route path="/terminos">
        <TerminosPage />
      </Route>

      <Route path="/auth/confirm-password/:token" component={ConfirmPassword} />
      <Route path="/auth/wallet/confirm-password/:token" component={WalletConfirmPassword} />

      {!isAuthorized ? (
        /*Render auth page when user at `/auth` and not authorized.*/
        <Route>
          <AuthPage />
        </Route>
      ) : (
        /*Otherwise redirect to root page (`/`)*/
        <Redirect from="/auth" to="/" />
      )}

      <Route path="/error" component={ErrorsPage} />
      <Route path="/logout" component={Logout} />

      {!isAuthorized ? (
        /*Redirect to `/auth` when user is not authorized*/
        <Redirect to="/auth/login" />
      ) : (
        <MasterLayout>
          <PrivateRoutes />
        </MasterLayout>
      )}
    </Switch>
  );
};

export { Routes };
